import React from "react";
import { Message } from "semantic-ui-react";
import { IOrderInfo } from "../../lib/rxAutoMessages/rxAutoMessages";
import { ISortBoxItemModel } from "../../lib/SortBoxItem/ISortBoxItemModel";

export const RxOrderInfo = ({ orderInfo, prefillBags = 0 }: { orderInfo: IOrderInfo, prefillBags: number }) => {
  let doneQuantity = 0;
  let snoozedQuantity = 0;
  let totaltQuantity = 0;
  let currentRxBagID: number | null = 0;

  if (orderInfo && orderInfo !== null && orderInfo.SortBoxes && orderInfo.SortBoxes.length > 0) {
    doneQuantity = orderInfo.SortBoxes.filter((box) => box.Done).length;
    snoozedQuantity = orderInfo.SortBoxes.filter((box) => box.Snoozed).length;
    totaltQuantity = orderInfo.SortBoxes.length;
    const currentRxBag = orderInfo.SortBoxes.find(
      (sb) => sb.SortBoxID === orderInfo.CurrentSortBoxID
    );
    currentRxBagID = currentRxBag ? currentRxBag.RxBagID : 0;
  }

  return (
    <Message
      style={{
        margin: "5px 0 0 0",
      }}
      size="huge"
      info
      className="OperatorInstructionMessageSmall flexColumn spaceBetween"
    >
      {currentRxBagID > 0 ? (
        <div style={{ alignSelf: "left" }}>Påsnummer: {currentRxBagID}</div>
      ) : null}
      {totaltQuantity > 0 ? (
        <div style={{ alignSelf: "left" }}>
          Klara påsar: {doneQuantity + prefillBags} / {totaltQuantity + prefillBags}
        </div>
      ) : null}
      {snoozedQuantity > 0 && doneQuantity < totaltQuantity ? (
        <div style={{ alignSelf: "left" }}>Snoozade: {snoozedQuantity}</div>
      ) : null}
      {prefillBags > 0 ? (
        <div style={{ alignSelf: "left" }}>Prefillpåsar: {prefillBags}</div>
      ) : null}
      {orderInfo.BoxBarcode ? (
        <div style={{ alignSelf: "left" }}>Låda: {orderInfo.BoxBarcode}</div>
      ) : null}
    </Message>
  );
};
